import { getAxiosBackendApi } from "../helpers/axios"
import store from '@/state/store'

class ArtistFormServices{

    constructor(){
    }
    
    getByUuid(uuid){
        return getAxiosBackendApi().get('site/'+ store.state.layout.local +'/form/verify/'+ uuid.toString())
    }

    search(data){
        return getAxiosBackendApi().get('site/'+ store.state.layout.local +'/form/search', {params: data})
    }

    add(data){
        return getAxiosBackendApi().post('site/'+ store.state.layout.local +'/form', data)
    }

}

export default new ArtistFormServices()